var map = {
	"./Performances/2022_03_12_SpiceRack/FullBandPlaying.jpg": 4955,
	"./Performances/2022_03_12_SpiceRack/Fullbandsick3.jpg": 9611,
	"./Performances/2022_03_12_SpiceRack/JunRedBacklight.jpg": 8695,
	"./Performances/2022_03_12_SpiceRack/KieranGuitar.jpg": 5807,
	"./Performances/2022_03_12_SpiceRack/PJfrontKieranBackGreen.jpg": 5817,
	"./Performances/2022_03_12_SpiceRack/bigJunbass2.jpg": 4493,
	"./Performances/2023_08_11_Annex/annex1-min.jpg": 754,
	"./Performances/2023_08_11_Annex/annex2-min.jpg": 9702,
	"./Performances/2023_08_11_Annex/annex3-min.jpg": 6160,
	"./Performances/2023_08_11_Annex/annex4-min.jpg": 1976,
	"./Performances/2023_08_11_Annex/annex5-min.jpg": 2191,
	"./Performances/2023_08_11_Annex/concert.jpg": 7255,
	"./Performances/2024_03_09_Annex/IMG_7075.jpg": 5910,
	"./Performances/2024_03_09_Annex/IMG_7105.jpg": 6394,
	"./Performances/2024_03_09_Annex/IMG_7130.jpg": 8458,
	"./Performances/2024_03_09_Annex/IMG_7213.jpg": 345,
	"./Performances/2024_03_09_Annex/IMG_7219.jpg": 9538,
	"./Performances/2024_03_09_Annex/IMG_7288.jpg": 122,
	"./Performances/2025_01_24_BeatKitchen/beatkitchen1.jpg": 9307,
	"./Performances/2025_01_24_BeatKitchen/beatkitchen2.jpg": 7334,
	"./Performances/2025_01_24_BeatKitchen/beatkitchen3.jpg": 6866,
	"./Performances/2025_01_24_BeatKitchen/beatkitchen4.jpg": 2151,
	"./Performances/2025_01_24_BeatKitchen/beatkitchen5.jpg": 6621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;